<template>
  <div class="main">
    <p class="p1">{{ min1 }}</p>
    <p class="p2">{{ min2 }}</p>
    <p class="p3">:</p>
    <p class="p4">{{ sec1 }}</p>
    <p class="p5">{{ sec2 }}</p>
  </div>
</template>

<script>
export default {
  props: {
    seconds: {
      type: Number,
      required: true,
    },
    timer: {
      type: Number,
      default: 5,
    },
    hasTimer: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      min1: 0,
      min2: 0,
      sec1: 0,
      sec2: 0,
    };
  },
  emits: ["timerFinish"],

  watch: {
    sec2() {
      if (this.min1 === 0 && this.min2 === 0 && this.sec1 === 0 && this.sec2 === 0) {
        this.$emit("timerFinish");
      }

      if (this.hasTimer && this.sec2 % this.timer === 0) {
        this.$emit("timerTicks");
      }
    },
  },

  methods: {
    timerFunc() {
      let time = this.seconds;

      this.min1 = Math.floor(this.seconds / 60 / 10);
      this.min2 = Math.floor(this.seconds / 60) % 10;
      this.sec1 = Math.floor((this.seconds % 60) / 10);
      this.sec2 = (this.seconds % 60) % 10;

      let timer = setInterval(() => {
        let min = Math.floor(time / 60);
        let sec = time % 60;
        if (time === 0) {
          clearInterval(timer);
        }

        time -= 1;

        this.min1 = Math.floor(min / 10);
        this.min2 = min % 10;
        this.sec1 = Math.floor(sec / 10);
        this.sec2 = sec % 10;
      }, 1000);
    },
  },

  mounted() {
    this.$nextTick(this.timerFunc);
  },
};
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
  margin: 0 0 30px;
  display: flex;
  min-height: auto;
  justify-content: center;
  background: none;
  gap: 5px;
  .p1,
  .p2,
  .p4,
  .p5 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 100px;
    background: white;
    box-shadow: 0px 12px 24px rgba(0, 0, 0, 0.1);
    border-radius: 9px;
    font-family: "Gilroy";
    font-style: normal;
    font-weight: 500;
    font-size: 48px;
    line-height: 100%;
    color: var(--general-color);
  }
  .p3 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 100px;
    font-style: normal;
    font-weight: 500;
    font-size: 48px;
    line-height: 100%;
  }
}
@media screen and (max-width: 550px) {
  .main {
    margin: 0 0 14px;
    width: 90%;
  }
}
@media screen and (max-width: 450px) {
  .main {
    height: 70px;
    .p1,
    .p2,
    .p3,
    .p4,
    .p5 {
      width: 80%;
      height: 100%;
      font-size: 30px;
    }
  }
}
</style>
